// extracted by mini-css-extract-plugin
export default {"block":"index_block_yogzz","list":"index_list_T-VDN","item":"index_item_IuJi3"};